'use client'
import { useProductDetailV2State } from '@/features/products/contexts/product-detail'
import { useDebounce } from '@/hooks'
import { useCartStore } from '@/store'
import { createContext, useContext, useMemo } from 'react'
import { useHandleVoucher } from '../hooks/use-handle-voucher'
import { usePromotionWithoutCart } from '../hooks/use-promotion'

type VoucherProviderProps = {
  children: React.ReactNode
  product: Product | null
}
type VoucherContextType = {
  listPromotionProps: {
    // cartId: string
    sku: string
    qty: number
    voucher: string
  }
  caculatedQuantity: number
  currentItemsInCart: number
}
const VoucherContext = createContext<VoucherContextType | undefined>(undefined)

export const VoucherProvider = ({ children, product }: VoucherProviderProps) => {
  const { cartData, cartItems } = useCartStore()
  const { quantity } = useProductDetailV2State()
  const caculatedQuantity = useDebounce(quantity, 400) as number
  const currentSku = useMemo(
    () => product?.variants?.find((item) => item?.product?.sku)?.product?.sku || product?.sku || '',
    [product]
  )

  const currentItemsInCart = useMemo(() => {
    const parrentSku = product?.sku || ''
    return cartItems?.reduce((acc, item) => {
      if (item?.product?.sku === parrentSku) {
        return acc + item?.quantity
      }
      return acc
    }, 0)
  }, [product?.sku, cartItems])

  // const caculatedQuantity = useMemo(() => {
  //   const parrentSku = product?.sku || ''
  //   return cartItems?.reduce((acc, item) => {
  //     if (item?.product?.sku === parrentSku) {
  //       return acc + item?.quantity
  //     }
  //     return acc
  //   }, tempQuantity)
  // }, [cartItems, product?.sku, tempQuantity])
  const activeCodeFromCart = useMemo(() => cartData?.applied_coupons?.[0]?.code, [cartData?.applied_coupons])
  const listPromotionProps = useMemo(() => {
    return {
      // cartId,
      sku: currentSku,
      qty: caculatedQuantity,
      voucher: activeCodeFromCart || '',
    }
  }, [currentSku, caculatedQuantity, activeCodeFromCart])

  // const { data, isLoading } = usePromotion(listPromotionProps)
  const { data, isLoading } = usePromotionWithoutCart({ ...listPromotionProps })
  useHandleVoucher({ data, isLoading })

  return (
    <VoucherContext.Provider
      value={{
        listPromotionProps,
        caculatedQuantity,
        currentItemsInCart,
      }}
    >
      {children}
    </VoucherContext.Provider>
  )
}

export const useVoucherContext = () => {
  const context = useContext(VoucherContext)
  if (!context) {
    throw new Error('useVoucherContext must be used within a VoucherProvider')
  }
  return context
}
